const GIFT_DEBOUNCE_MS = 220;
let giftDebounceTimer = null;
let giftSyncInFlight = false;
let giftSyncPending = false;
let giftPendingOnDone = null;

const EXCLUSIVE_GIFT_OPT_OUT_KEY = 'exclusive_gift_opt_out';

function isExclusiveGiftOptedOut(variantId) {
  const raw = localStorage.getItem(EXCLUSIVE_GIFT_OPT_OUT_KEY);
  if (!raw) {
    console.log('[DEBUG isExclusiveGiftOptedOut]', variantId, '→ no key found');
    return false;
  }
  const result = raw.indexOf(String(variantId)) !== -1;
  console.log('[DEBUG isExclusiveGiftOptedOut]', variantId, 'key=', raw, '→', result);
  return result;
}

function addExclusiveGiftOptOut(variantId) {
  if (variantId == null || variantId === '') return;
  const sid = String(variantId);
  const raw = localStorage.getItem(EXCLUSIVE_GIFT_OPT_OUT_KEY) || '';
  if (!raw) {
    localStorage.setItem(EXCLUSIVE_GIFT_OPT_OUT_KEY, sid);
  } else if (raw.indexOf(sid) === -1) {
    localStorage.setItem(EXCLUSIVE_GIFT_OPT_OUT_KEY, raw + ',' + sid);
  }
  console.log('[DEBUG addExclusiveGiftOptOut]', sid, '→', localStorage.getItem(EXCLUSIVE_GIFT_OPT_OUT_KEY));
}

function flushExclusiveOnDone() {
  const onDone = giftPendingOnDone;
  giftPendingOnDone = null;
  if (typeof onDone === 'function') {
    onDone();
  }
}

function getExclusiveGiftConfig() {
  const cfg = typeof window !== 'undefined' ? window.__exclusiveVariantGifts : null;
  if (!cfg) return null;
  // 新扁平格式：groups 在顶层
  if (cfg.groups) return cfg;
  // 旧格式兼容：groups 在 .opendots2 子键下
  return cfg.opendots2 || null;
}

function getExclusivePropertyKey() {
  return getExclusiveGiftConfig()?.propertyKey || '_ExclusiveGift';
}

function buildMainVariantToGroupMap(groups) {
  const map = new Map();
  if (!groups) {
    return map;
  }
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    const ids = group.mainVariantIds || [];
    for (let j = 0; j < ids.length; j++) {
      map.set(String(ids[j]), group);
    }
  }
  return map;
}

function collectAllGiftVariantIds(groups) {
  const ids = new Set();
  if (!groups) {
    return ids;
  }
  for (let i = 0; i < groups.length; i++) {
    const group = groups[i];
    if (group.gift_1_VariantId) {
      ids.add(String(group.gift_1_VariantId));
    }
    if (group.gift_2_VariantId) {
      ids.add(String(group.gift_2_VariantId));
    }
  }
  return ids;
}

function qtyForVariantInCart(items, variantId) {
  const sid = String(variantId);
  let qty = 0;
  for (let i = 0; i < items.length; i++) {
    if (String(items[i].variant_id) === sid) {
      qty += items[i].quantity;
    }
  }
  return qty;
}

function isGiftVariantOptedOut(variantId) {
  const oldRaw = localStorage.getItem('product_gifts');
  if (oldRaw && oldRaw.indexOf(String(variantId)) !== -1) {
    console.log('[DEBUG isGiftVariantOptedOut]', variantId, 'found in product_gifts:', oldRaw);
    return true;
  }
  const result = isExclusiveGiftOptedOut(variantId);
  console.log('[DEBUG isGiftVariantOptedOut]', variantId, 'exclusive check →', result);
  return result;
}

function applyProductGiftsOptOut(targets, items) {
  const result = new Map(targets);
  for (const [giftVariantId, targetQty] of targets) {
    if (!isGiftVariantOptedOut(giftVariantId)) {
      continue;
    }
    const currentQty = qtyForVariantInCart(items, giftVariantId);
    if (targetQty > currentQty) {
      console.log('[DEBUG applyProductGiftsOptOut] CAPPING', giftVariantId, 'target=', targetQty, '→', currentQty);
      result.set(giftVariantId, currentQty);
    } else {
      console.log('[DEBUG applyProductGiftsOptOut] SKIP', giftVariantId, 'target=', targetQty, 'current=', currentQty, '(target ≤ current)');
    }
  }
  return result;
}

function computeTargetGiftQuantities(cart, config) {
  const groups = config.groups || [];
  const variantToGroup = buildMainVariantToGroupMap(groups);
  const targets = new Map();
  const allGiftIds = collectAllGiftVariantIds(groups);

  for (const giftId of allGiftIds) {
    targets.set(giftId, 0);
  }

  const items = cart.items || [];
  for (let i = 0; i < items.length; i++) {
    const line = items[i];
    const group = variantToGroup.get(String(line.variant_id));
    if (!group) continue;

    const qty = line.quantity || 0;
    const props = line.properties || {};
    const giftPrefix = '_G_';
    const pdpMarker = '_G_FromPdp';

    // 判断该行是否来自 PDP（有 _G_FromPdp 标记或任意 _G_ 前缀属性）
    const isPdpSourced = props[pdpMarker] === '1' || Object.keys(props).some(function (k) {
      return k.indexOf(giftPrefix) === 0;
    });

    console.log('[DEBUG computeTarget] line.variant=', line.variant_id, 'qty=', qty, 'isPdp=', isPdpSourced, 'props=', JSON.stringify(props));

    if (isPdpSourced) {
      // PDP 来源的行：只加用户勾选的赠品
      if (group.gift_1_VariantId && props[giftPrefix + String(group.gift_1_VariantId)]) {
        const id = String(group.gift_1_VariantId);
        targets.set(id, (targets.get(id) || 0) + qty);
      }
      if (group.gift_2_VariantId && props[giftPrefix + String(group.gift_2_VariantId)]) {
        const id = String(group.gift_2_VariantId);
        targets.set(id, (targets.get(id) || 0) + qty);
      }
      // PDP 来源但无勾选：targets 保持初始化时的 0
    } else {
      // 非 PDP 来源的行：默认加所有赠品
      if (group.gift_1_VariantId) {
        const id = String(group.gift_1_VariantId);
        targets.set(id, (targets.get(id) || 0) + qty);
      }
      if (group.gift_2_VariantId) {
        const id = String(group.gift_2_VariantId);
        targets.set(id, (targets.get(id) || 0) + qty);
      }
    }
  }

  console.log('[DEBUG computeTarget] before opt-out:', JSON.stringify(Object.fromEntries(targets)));
  const result = applyProductGiftsOptOut(targets, items);
  console.log('[DEBUG computeTarget] after opt-out:', JSON.stringify(Object.fromEntries(result)));
  return result;
}

function buildGiftUpdates(targets, items, groups) {
  const allGiftIds = collectAllGiftVariantIds(groups);
  const updates = {};
  let hasChanges = false;

  for (const giftId of allGiftIds) {
    const target = targets.get(String(giftId)) || 0;
    const current = qtyForVariantInCart(items, giftId);
    if (target !== current) {
      updates[String(giftId)] = target;
      hasChanges = true;
    }
  }

  return hasChanges ? updates : null;
}

function runSyncExclusiveGifts() {
  const config = getExclusiveGiftConfig();
  if (!config?.groups?.length) {
    flushExclusiveOnDone();
    return Promise.resolve(false);
  }
  if (giftSyncInFlight) {
    giftSyncPending = true;
    return Promise.resolve(false);
  }

  if ((window.__exclusiveGiftRetryCount || 0) >= 5) {
    window.__exclusiveGiftRetryCount = 0;
    if (giftSyncPending) {
      giftSyncPending = false;
    }
    flushExclusiveOnDone();
    console.warn('exclusive gift sync: max retries reached, stopping');
    return Promise.resolve(false);
  }

  giftSyncInFlight = true;
  let actuallyUpdated = false;

  return Promise.all([
    fetch('/cart.js').then(function (response) { return response.json(); }),
    getExclusiveGiftOutOfStockIds(config)
  ])
    .then(function (results) {
      const cart = results[0];
      const outOfStockIds = results[1];
      const items = cart.items || [];
      const targets = computeTargetGiftQuantities(cart, config);

      // 售罄 pair 的赠品目标清零
      if (outOfStockIds.size > 0) {
        for (const [variantId, qty] of targets) {
          if (outOfStockIds.has(variantId)) {
            targets.set(variantId, 0);
          }
        }
      }

      const updates = buildGiftUpdates(targets, items, config.groups);
      if (!updates) {
        return null;
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      }).then(function (response) { return response.json(); });
    })
    .then(function (updated) {
      if (updated) {
        actuallyUpdated = true;
        typeof publish === 'function' && publish(PUB_SUB_EVENTS.cartUpdate, { source: 'exclusive-gift' });
      }
      return Boolean(updated);
    })
    .catch((error) => {
      console.error('exclusive gift sync:', error);
      return false;
    })
    .finally(() => {
      if (actuallyUpdated) {
        window.__exclusiveGiftRetryCount = (window.__exclusiveGiftRetryCount || 0) + 1;
      }
      giftSyncInFlight = false;
      if (giftSyncPending) {
        giftSyncPending = false;
        runSyncExclusiveGifts();
        return;
      }
      flushExclusiveOnDone();
    });
}

/**
 * 检查单个 group 的赠品对库存。
 * 只有同时存在两个赠品且配置了 ProductHandle 时才触发检查。
 * 任意一个售罄时，返回两个赠品的 variantId 数组以阻止加购。
 * 网络请求失败时保守降级，返回 []（假设有货）。
 */
function checkGiftPairStock(group) {
  if (!group.gift_1_VariantId || !group.gift_2_VariantId) {
    return Promise.resolve([]);
  }
  if (!group.gift_1_ProductHandle || !group.gift_2_ProductHandle) {
    return Promise.resolve([]);
  }

  return Promise.all([
    fetch('/products/' + group.gift_1_ProductHandle + '.js').then(function (r) { return r.json(); }),
    fetch('/products/' + group.gift_2_ProductHandle + '.js').then(function (r) { return r.json(); })
  ]).then(function (results) {
    const product1 = results[0];
    const product2 = results[1];
    const v1 = product1.variants.find(function (v) { return String(v.id) === String(group.gift_1_VariantId); });
    const v2 = product2.variants.find(function (v) { return String(v.id) === String(group.gift_2_VariantId); });

    if ((v1 && !v1.available) || (v2 && !v2.available)) {
      return [String(group.gift_1_VariantId), String(group.gift_2_VariantId)];
    }
    return [];
  }).catch(function () {
    // 请求失败时保守降级，假设有货
    return [];
  });
}

/**
 * 遍历所有 group，并行检查赠品对库存。
 * 返回所有需要阻止加购的 variant ID Set。
 */
function getExclusiveGiftOutOfStockIds(config) {
  var groups = (config && config.groups) || [];
  if (!groups.length) {
    return Promise.resolve(new Set());
  }

  var checks = [];
  for (var i = 0; i < groups.length; i++) {
    checks.push(checkGiftPairStock(groups[i]));
  }

  return Promise.all(checks).then(function (results) {
    var outOfStock = new Set();
    for (var i = 0; i < results.length; i++) {
      var ids = results[i];
      for (var j = 0; j < ids.length; j++) {
        outOfStock.add(ids[j]);
      }
    }
    return outOfStock;
  });
}

function scheduleSyncExclusiveGifts(onDone) {
  if (typeof onDone === 'function') {
    giftPendingOnDone = onDone;
  }
  if (giftDebounceTimer) {
    clearTimeout(giftDebounceTimer);
  }
  giftDebounceTimer = setTimeout(() => {
    giftDebounceTimer = null;
    runSyncExclusiveGifts();
  }, GIFT_DEBOUNCE_MS);
}

function isExclusiveMainVariantId(variantId) {
  const config = getExclusiveGiftConfig();
  if (!config?.groups?.length || variantId == null) {
    return false;
  }
  const sid = String(variantId);
  for (let i = 0; i < config.groups.length; i++) {
    const ids = config.groups[i].mainVariantIds || [];
    for (let j = 0; j < ids.length; j++) {
      if (String(ids[j]) === sid) {
        return true;
      }
    }
  }
  return false;
}

function isExclusiveGiftPdp() {
  const config = getExclusiveGiftConfig();
  if (!config) {
    return false;
  }
  const handles = config.pdpProductHandles?.length
    ? config.pdpProductHandles
    : config.pdpProductHandle
      ? [config.pdpProductHandle]
      : [];
  for (let i = 0; i < handles.length; i++) {
    if (window.location.pathname.includes(`/products/${handles[i]}`)) {
      return true;
    }
  }
  return false;
}

// 全局导出
window.scheduleSyncExclusiveGifts = scheduleSyncExclusiveGifts;
window.runSyncExclusiveGifts = runSyncExclusiveGifts;
window.isExclusiveMainVariantId = isExclusiveMainVariantId;
window.isExclusiveGiftPdp = isExclusiveGiftPdp;
window.getExclusiveGiftConfig = getExclusiveGiftConfig;
window.getExclusivePropertyKey = getExclusivePropertyKey;
window.computeTargetGiftQuantities = computeTargetGiftQuantities;
window.buildGiftUpdates = buildGiftUpdates;
window.getExclusiveGiftOutOfStockIds = getExclusiveGiftOutOfStockIds;
window.addExclusiveGiftOptOut = addExclusiveGiftOptOut;

// 向后兼容 —— 旧函数名作为别名
window.scheduleSyncOpendots2Gifts = scheduleSyncExclusiveGifts;
window.runSyncOpendots2Gifts = runSyncExclusiveGifts;
window.isOpendots2MainVariantId = isExclusiveMainVariantId;
window.isOpendots2Pdp = isExclusiveGiftPdp;
window.getOpendots2PropertyKey = getExclusivePropertyKey;
window.shouldAttachOpendots2GiftProperty = function () { return false; };
window.getOpendots2GiftPropertyForPdp = function () { return 'towel'; };
window.getLineGiftChoice = function () { return 'towel'; };
window.addOpendots2MainViaCart = function () {
  return Promise.resolve(null);
};
